"use client";

import { BOARDS, PIECES, type BoardFinish, type PieceFinish, type PieceStyle } from "@/lib/appearance";
import { useAppearance } from "@/components/site/AppearanceProvider";
import { PieceArt } from "./PieceArt";

export function AppearanceControls({ compact = false }: { compact?: boolean }) {
  const { appearance, update } = useAppearance();
  return <div className={`appearance-controls ${compact ? "compact" : ""}`}>
    <fieldset><legend>Board material</legend><div className="material-grid">
      {(Object.keys(BOARDS) as BoardFinish[]).map((key) => {
        const board = BOARDS[key];
        return <button type="button" key={key} className="material-option" aria-pressed={appearance.board === key} onClick={() => update({ board: key })}>
          <span className="board-swatch" style={{ backgroundColor: board.light, backgroundImage: `url(/materials/${board.texture}.webp)` }}><span style={{ backgroundColor: board.dark, backgroundImage: `url(/materials/${board.texture}.webp)` }}/><span style={{ backgroundColor: board.dark, backgroundImage: `url(/materials/${board.texture}.webp)` }}/></span>
          <strong>{board.name}</strong>{!compact && <small>{board.description}</small>}
        </button>;
      })}
    </div></fieldset>
    <fieldset><legend>Piece finish</legend><div className="material-grid">
      {(Object.keys(PIECES) as PieceFinish[]).map((key) => <button type="button" key={key} className="material-option" aria-pressed={appearance.pieces === key} onClick={() => update({ pieces: key })}>
        <span className="piece-swatch"><PieceArt type="n" color="w" finish={key} style={appearance.style}/><PieceArt type="p" color="b" finish={key} style={appearance.style}/></span>
        <strong>{PIECES[key].name}</strong>{!compact && <small>{PIECES[key].description}</small>}
      </button>)}
    </div></fieldset>
    <fieldset><legend>Piece design</legend><div className="segmented w-full">
      {(["staunton", "modern"] as PieceStyle[]).map((style) => <button type="button" key={style} aria-pressed={appearance.style === style} onClick={() => update({ style })}>{style === "staunton" ? "Classic Staunton" : "Modern atelier"}</button>)}
    </div></fieldset>
  </div>;
}
